import React from 'react';
import lscache from 'lscache';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { withErrorBoundary } from 'react-scale/containers/global/errorBoundary';

interface IHideableNavSectionProps {
  name: string;
  forceHidden?: boolean;
  component: React.ReactNode;
}

interface IHideableNavSectionState {
  hidden: boolean;
}

class HideableNavSection extends React.Component<
  IHideableNavSectionProps,
  IHideableNavSectionState
> {
  constructor(props: IHideableNavSectionProps) {
    super(props);

    const hidden = props.forceHidden || lscache.get(this.getCacheKey(props.name)) || false;

    this.state = {
      hidden,
    };
  }

  toggleHidden = (): void => {
    const { hidden } = this.state;
    this.setState({
      hidden: !hidden,
    });
    lscache.set(this.getCacheKey(this.props.name), !hidden);
  };

  getCacheKey(name: string): string {
    return `hideablesection/${name}/hidden`;
  }

  render() {
    const { name, component } = this.props;
    const { hidden } = this.state;
    if (!component) {
      return null;
    }

    return (
      <div className="section">
        <div className="section-header" onClick={this.toggleHidden}>
          <em>
            {hidden ? (
              <FontAwesomeIcon icon="caret-right" />
            ) : (
              <FontAwesomeIcon icon="caret-down" />
            )}
          </em>
          {name}
        </div>

        {!hidden && <div className="section-body">{component}</div>}

        <style jsx>{`
          .section {
            margin-bottom: 16px;
            white-space: nowrap;
            opacity: 1;
            transition: opacity 0.5s ease-in-out;
          }

          .section-header {
            margin: 0 0 4px;
            color: white;
            font-size: 13px;
            text-transform: uppercase;
            font-weight: bold;
            color: rgba(150, 150, 150, 1);
            letter-spacing: 0.5px;
            cursor: pointer;
          }

          .section-header em {
            display: inline-block;
            width: 15px;
          }
        `}</style>
      </div>
    );
  }
}

export default withErrorBoundary({ reloadable: true })(HideableNavSection);
